import { CommonModule } from '@angular/common';
import { Component, input, output, computed } from '@angular/core';
import { StepperModule } from 'primeng/stepper';
interface Step {
  value: number;
  label: string;
  disabled?: boolean;
}
interface ValueChangeEvent {
  value: number;
  isClick: boolean;
  stepCurrent: number;
}
@Component({
  selector: 'app-stepper',
  imports: [CommonModule, StepperModule],
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  standalone: true,
})
export class StepperComponent {
  steps = input<Step[]>([{ value: null, label: '', disabled: false }]);
  stepCurrent = input<number>(1);
  linear = input<boolean>(false);

  valueChange = output<ValueChangeEvent>();
  value: number | null = null;
  disabledSteps = computed(
    () =>
      new Set<number>(
        this.steps()
          .filter((step) => step.disabled)
          .map((step) => step.value)
      )
  );

  onStepChange(event: number) {
    if (this.disabledSteps().has(event)) {
      return;
    }
    this.value = event;
    this.valueChange.emit({
      value: this.value,
      stepCurrent: this.stepCurrent(),
      isClick: true,
    });
  }

  isStepDisabled(step: number): boolean {
    return this.disabledSteps().has(step);
  }
}
